import { invoke } from '@forge/bridge'
import { useEffect } from 'react'
import { logError } from '@/components/Error/Error'
import { Layout } from '@/components/Layout/Layout'
import { useRadarNav } from '@/lib/state'
import styles from './success.module.css'

type SubscriptionTier = 'BASIC' | 'PRO'

const SuccessPage = () => {
  const { route } = useRadarNav()

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const _status = await invoke<{
          isLicensed: boolean
          tier: SubscriptionTier | null
        }>('checkSubscriptionStatus')
      } catch (error) {
        logError('SuccessPage', 'Error checking subscription status:', error)
      }
    }

    checkSubscription()
  }, [])

  return (
    <Layout>
      <div data-testid="success-page" className={styles.container}>
        <div data-testid="success-message" className={styles.content}>
          <div className={styles.icon}>✓</div>
          <h1 className={styles.title}>Purchase Successful!</h1>
          <p className={styles.message}>
            Thank you for your purchase. Your Tech Radar license has been
            successfully updated.
          </p>
          <div data-testid="success-actions">
            <button
              type="button"
              className={styles.button}
              onClick={() => route('')}
            >
              Return to Tech Radar
            </button>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default SuccessPage
